var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"argdown-input",class:{'use-argvu': _vm.useArgVu}},[_c('codemirror',{ref:"codemirror",attrs:{"options":_vm.editorOption,"value":_vm.value},on:{"changes":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }